import { BackgroundEffectsType } from '@enums';
import { BackgroundEffect } from '../models/background-effect.model';

export const BACKGROUND_EFFECTS: BackgroundEffect[] = [
  { name: 'None', value: BackgroundEffectsType.none, class: 'none' },
  { name: 'Blur', value: BackgroundEffectsType.blur, class: 'blur' }
];
